export const IMPROVES_FEATURES = [
  {
    id: 1,
    title: "HOME.STATISTICS.IMPROVES.1",
  },
  {
    id: 2,
    title: "HOME.STATISTICS.IMPROVES.2",
  },
  {
    id: 3,
    title: "HOME.STATISTICS.IMPROVES.3",
  },
  {
    id: 4,
    title: "HOME.STATISTICS.IMPROVES.4",
  },
  {
    id: 5,
    title: "HOME.STATISTICS.IMPROVES.5",
  },
  {
    id: 6,
    title: "HOME.STATISTICS.IMPROVES.6",
  },
  {
    id: 7,
    title: "HOME.STATISTICS.IMPROVES.7",
  },
  {
    id: 8,
    title: "HOME.STATISTICS.IMPROVES.8",
  },
  {
    id: 9,
    title: "HOME.STATISTICS.IMPROVES.9",
  },
  {
    id: 10,
    title: "HOME.STATISTICS.IMPROVES.10",
  },
  {
    id: 11,
    title: "HOME.STATISTICS.IMPROVES.11",
  },
  {
    id: 12,
    title: "HOME.STATISTICS.IMPROVES.12",
  },
];
